import { render, staticRenderFns } from "./MacroFileList.vue?vue&type=template&id=2a33780b"
import script from "./MacroFileList.vue?vue&type=script&lang=ts"
export * from "./MacroFileList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports